import React, { useEffect, useReducer, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import tw from "tailwind-styled-components";
import { PrimaryText, TimeOutModal } from "@components";
import { getSelectedPlayerData } from "@store";

function Timer(props) {
  const { t } = useTranslation("common");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isModals = useSelector((state) => state.header.isModal);
  const apiTimer = useSelector((state) => state.setting.time);
  const timer = apiTimer?.data?.data?.countDown;

  const [state, setState] = useReducer(
    (state, newState) => ({ ...state, ...newState }),
    {
      showTimer: false,
      timeOutModal: false,
    }
  );
  const [countDownTime, setCountDownTime] = useState(180);

  useEffect(() => {
    if (timer) {
      setCountDownTime(timer * 60);
    }
  }, [timer]);

  let interval = null;
  useEffect(() => {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    interval = setInterval(() => {
      if (!isModals) {
        setCountDownTime((countDownTime) => countDownTime - 1);
      }
    }, 1000);
    return () => clearInterval(interval);
  }, [isModals, countDownTime]);

  if (countDownTime === 0) {
    setTimeout(() => {
      clearInterval(interval);
    }, 1000);
    if (state.showTimer) {
      setState({ showTimer: false, timeOutModal: true });
    }
  } else {
    if (!state.showTimer) {
      setState({ showTimer: true, timeOutModal: false });
    }
  }
  const minutes = Math.floor(countDownTime / 60);
  const seconds = countDownTime - minutes * 60;

  const closeModal = () => {
    dispatch(getSelectedPlayerData({ save: false }));
    setState({ timeOutModal: false });
    navigate(-1);
  };

  const reStartModal = () => {
    setCountDownTime(timer * 60);
    setState({ timeOutModal: false });
  };

  return (
    <>
      {state.showTimer && timer && (
        <TimerView>
          <PrimaryText className={timerTxt}>
            {`${t("checkOut.timer.you")} ${
              minutes ? minutes + `${t("checkOut.timer.min")}` : ""
            } ${seconds} ${t("checkOut.timer.sec")}`}
          </PrimaryText>
        </TimerView>
      )}
      <TimeOutModal
        openModal={state.timeOutModal}
        closeModal={closeModal}
        reStartModal={reStartModal}
        title={props.title}
      />
    </>
  );
}

const TimerView = tw.div`
w-full 
max-w-[1500px]
h-auto 
mb-[10px] 
flex 
justify-center 
items-center 
p-2 
z-30
`;
const timerTxt = `
text-red255 
text-center 
font-semibold 
text-lg
`;

export default Timer;
